/**
 * Checkout (Saleor channel) currency helpers.
 */

export const SALEOR_CHANNEL_SLUGS = ["standard"] as const;
export type SaleorChannelSlug = (typeof SALEOR_CHANNEL_SLUGS)[number];

/** Canonical settlement currency per storefront channel (matches Saleor). */
export const CHECKOUT_CURRENCY_BY_CHANNEL: Record<SaleorChannelSlug, string> = {
	standard: "EUR",
};

/**
 * Settlement currency for the storefront. Single channel (`standard`) settles in EUR.
 */
export function getCheckoutCurrencyCode(_channelSlug: string): "EUR" | "USD" {
	return "EUR";
}
